import { getUnitDistribution } from "drinkaware-tools-api-library";
import { Gender } from "@dcc/types/gender";
import { dataApi } from "@dcc/api";
import {
  UnitDistributionResponse,
  UnitDistributionResponseDistItem
} from "drinkaware-tools-api-library/dist/src/clients/data/src";

let unitDistribution: UnitDistributionResponse;

const getPercentageOfPopulation = (
  gender: Gender,
  units: number
): number | undefined => {
  if (!unitDistribution || !unitDistribution.dist) {
    return undefined;
  }

  const entry = unitDistribution.dist.find((u) => u.units === units);
  if (entry) {
    return gender === Gender.Male ? entry.malePercent : entry.femalePercent;
  } else if (unitDistribution.dist.length > 0) {
    const maxEntry = unitDistribution.dist[unitDistribution.dist.length - 1];
    return gender === Gender.Male
      ? maxEntry.malePercent
      : maxEntry.femalePercent;
  } else {
    return undefined;
  }
};

export const getUnitsForTargetPercentage = (
  gender: Gender,
  percentage: number
): number | undefined => {
  const condition =
    gender === Gender.Male
      ? (unit: UnitDistributionResponseDistItem) =>
          unit.malePercent >= percentage
      : (unit: UnitDistributionResponseDistItem) =>
          unit.femalePercent >= percentage;

  if (!unitDistribution.dist) {
    return undefined;
  }
  const entry = unitDistribution.dist.find(condition);
  if (entry) {
    return entry.units;
  } else {
    return undefined;
  }
};

//TODO: between api and this call we need to handle error responses coming back i.e. specific http codes
//https://dev.azure.com/screenmedia/Drinkaware/_workitems/edit/22131/?workitem=22483
const fetchUnitDistribution = async () => {
  try {
    unitDistribution = await getUnitDistribution({ data: dataApi });
  } catch {
    // eslint-disable-next-line
    console.log("An error has occurred");
  }
};

export { unitDistribution, fetchUnitDistribution, getPercentageOfPopulation };
